import {
  COVERAGE_LEVEL_FAMILY_KEY,
  COVERAGE_LEVEL_FAMILY_LABEL,
  COVERAGE_LEVEL_SINGLE_KEY,
  COVERAGE_LEVEL_SINGLE_LABEL,
} from '@/modules/employee/Employee/EnrollmentModal/enrollmentModal.types.ts';

export function getCoverageLevel(coverageLevelLabel?: string) {
  if (coverageLevelLabel === COVERAGE_LEVEL_FAMILY_LABEL) return COVERAGE_LEVEL_FAMILY_KEY;
  if (coverageLevelLabel === COVERAGE_LEVEL_SINGLE_LABEL) return COVERAGE_LEVEL_SINGLE_KEY;
  return coverageLevelLabel;
}
